const PropTypes = require('prop-types')
const isLoggedIn = require('module/viewer/helpers/is_logged_in')

// component which renders children if the viewer is not logged in
function AnonymousComponent({ children }, { viewer }) {
    if (isLoggedIn(viewer)) return null
    return children
}
AnonymousComponent.propTypes = {
    children: PropTypes.any,
}
AnonymousComponent.contextTypes = {
    viewer: PropTypes.object.isRequired,
}

module.exports = {
    AnonymousComponent,
}
